import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const skeletonLineCss = "@keyframes skeleton-line-anim-bg{0%{background-position:0 0}to{background-position:100% 0}}@keyframes skeleton-line-anim-grow-x{0%{opacity:0;transform:scaleX(.1)}30%{opacity:1}to{transform:scaleX(1)}}:host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;animation:skeleton-line-anim-bg 1.5s linear .5s infinite reverse,skeleton-line-anim-grow-x .25s ease forwards;background:linear-gradient(90deg,var(--jw-theme-loader-skeleton-bg-color) 15%,var(--jw-theme-loader-skeleton-fade-bg-color) 25%,var(--jw-theme-loader-skeleton-bg-color) 35%,var(--jw-theme-loader-skeleton-bg-color) 65%,var(--jw-theme-loader-skeleton-fade-bg-color) 75%,var(--jw-theme-loader-skeleton-bg-color) 85%);background-size:200% 100%;border-radius:50%;border-radius:.25rem;box-sizing:border-box;display:block;flex:0 1 auto;flex-shrink:0;font-family:Open Sans;font-size:.875rem;font-weight:400;height:1.5rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;transform-origin:left;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([variable-width=direct]){max-width:100%}:host([variable-width=direct]):nth-of-type(odd){width:80%}:host([variable-width=direct]):nth-of-type(3n+2){width:50%}:host([variable-width=direct]):nth-of-type(5n+3){width:60%}:host([variable-width=direct]):nth-of-type(7n+5){width:40%}:host([variable-width=direct]):nth-of-type(11n+7){width:70%}:host([variable-width=nested]){max-width:100%}:nth-of-type(odd)>:host([variable-width=nested]){width:80%}:nth-of-type(3n+2)>:host([variable-width=nested]){width:50%}:nth-of-type(5n+3)>:host([variable-width=nested]){width:60%}:nth-of-type(7n+5)>:host([variable-width=nested]){width:40%}:nth-of-type(11n+7)>:host([variable-width=nested]){width:70%}";

const WuiSkeletonLine = /*@__PURE__*/ proxyCustomElement(class WuiSkeletonLine extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Render lines in different widths based on the position
         * in their parent element. Has two types:
         *
         * - direct: based on position in direct parent
         * - nested: based on position in parent one level up
         */
        this.variableWidth = 'direct';
    }
    render() {
        return h(Host, { key: '23da1ac3be854f649b760b0e8916b6f0ad72f02d' });
    }
    static get style() { return skeletonLineCss; }
}, [257, "wui-skeleton-line", {
        "variableWidth": [520, "variable-width"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-skeleton-line"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-skeleton-line":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiSkeletonLine);
            }
            break;
    } });
}
defineCustomElement();

export { WuiSkeletonLine as W, defineCustomElement as d };
